import React from "react";
import { get, isEmpty } from "lodash";
import { TableRow, TableCell } from "@material-ui/core";
import { TIMED_TEXT_SECTION } from "../../../constants/ContentFinder";
import { displayData, hasAnyValue } from "../../../utils/ContentFinderUtils";
import DrawerTable from "./DrawerTable";

const TimedTextSection = ({ timedTextTracks, versionCreatedAt }) => {
  const tracks = [...timedTextTracks]
    .filter((track) => {
      const properties = get(track, "properties", {});
      return hasAnyValue([
        get(properties, "writtenLanguage") || get(properties, "language"),
        get(properties, "description"),
        get(track, "dateAdded") || versionCreatedAt,
      ]);
    })
    .sort((a, b) =>
      a.trackNum === b.trackNum
        ? (b.version || 0) - (a.version || 0)
        : (a.trackNum || 0) - (b.trackNum || 0)
    );

  return (
    <DrawerTable
      title={TIMED_TEXT_SECTION.title}
      headers={TIMED_TEXT_SECTION.headers}
      isEmpty={isEmpty(tracks)}
      emptyMessage={TIMED_TEXT_SECTION.emptyMessage}
    >
      {tracks.map((track, i) => {
        const properties = get(track, "properties", {});
        let isBCP47 = true;
        let language = get(properties, "writtenLanguage");
        if (!language) {
          isBCP47 = false;
          language = get(properties, "language");
        }
        return (
          <TableRow key={i} className="tableRow content-finder-body-row">
            <TableCell className="content-finder-table-cell">
              {displayData(language, {
                displayLanguage: true,
                displayFallback: "N/A",
                isBCP47,
              })}
            </TableCell>
            <TableCell className="content-finder-table-cell">
              {displayData(get(properties, "description"), {
                displayFallback: "None",
              })}
            </TableCell>
            <TableCell className="content-finder-table-cell">
              {displayData(get(track, "dateAdded") || versionCreatedAt, {
                dateFormat: "YYYY-MM-DD",
              })}
            </TableCell>
          </TableRow>
        );
      })}
    </DrawerTable>
  );
};

export default TimedTextSection;
